import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import VueNumberInput from '@chenfengyuan/vue-number-input';


import 'vue-json-pretty/lib/styles.css';

import 'leaflet/dist/leaflet.css';

Vue.use(FlagIcon);

Vue.use(VueNumberInput);

Vue.config.productionTip = false

new Vue({
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')


